export default __webpack_public_path__ + "static/media/bg_5.f402c6bd.png";